/* eslint-disable no-unused-vars */
// LQC-2676 - a plain dropdown over a fixed vocabulary (option type, strike quotation,
// and the day count / frequency lists the swap ticket will need). DirectionSelect stays
// separate because it colours itself green or red; nothing else does.

interface ITicketSelect<T extends string> {
  value: T | "";
  onChange: (value: T) => void;
  options: T[];
  testId: string;
  placeholder?: string;
  // Off for a field that is always defaulted - an empty entry there is unreachable and
  // reads as a duplicate of the real option next to it.
  includeEmptyOption?: boolean;
}

const TicketSelect = <T extends string>({
  value,
  onChange,
  options,
  testId,
  placeholder = "Select ...",
  includeEmptyOption = true,
}: ITicketSelect<T>) => {
  return (
    <select
      data-testid={testId}
      id={testId}
      value={value}
      onChange={(e) => onChange(e.target.value as T)}
      className="h-[28px] w-full rounded-md border border-gray-300 bg-transparent px-1 text-xs outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200"
    >
      {includeEmptyOption && <option value="">{placeholder}</option>}
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export default TicketSelect;
